module.exports = __webpack_public_path__ + "img/china-app3.ffe38573.png";